import { render } from "./PdfIcon.vue?vue&type=template&id=0a623781"
import script from "./PdfIcon.vue?vue&type=script&lang=js"
export * from "./PdfIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__